import React from 'react';
import classNames from 'classnames';
import {
  makeStyles,
  tokens,
} from '@fluentui/react-components';

export const useStyles = makeStyles({
  cell: {
    position: 'absolute',
    height: '100%',
    borderLeftColor: tokens.colorNeutralBackground1Hover,
    borderLeftWidth: '5px',
    borderLeftStyle: 'solid',
    borderRightColor: tokens.colorNeutralBackground1Hover,
    borderRightWidth: '5px',
    borderRightStyle: 'solid',
    left: '5px',
    right: '5px',
    backgroundColor: tokens.colorNeutralBackground1Hover,
  },
  container: {
    // backgroundColor: tokens.colorNeutralBackground1Hover,
    left: '0px',
    width: '100%',
    height: '100%',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
  },
  negative: {
    height: '24px',
    position: 'absolute',
    backgroundColor: tokens.colorPaletteLilacForeground2,
    right: '50%',
  },
  middleMark: {
    position: 'absolute',
    height: '100%',
    width: '1px',
    backgroundColor: tokens.colorNeutralBackground1Pressed,
  },
  positive: {
    height: '24px',
    position: 'absolute',
    backgroundColor: tokens.colorPaletteBlueBorderActive,
    left: '50%',
  },
});

// Divide percentages by 2 because the width each section (positive and negative) should be half of the total width of the cell
function getBarWidth(change: number, maxChange: number) {
  return Math.abs((maxChange > 0 ? (change / maxChange) * 100 : 0) / 2);
}

export const ChangeBarCell = React.memo(({ change, maxChange }: { change: number, maxChange: number }) => {
  const classes = useStyles();

  const negativeBarWidth = change < 0 ? getBarWidth(change, maxChange) : 0;
  const positiveBarWidth = change > 0 ? getBarWidth(change, maxChange) : 0;

  return (
    <div className={classes.cell}>
      <div className={classNames(classes.container)}>
        <div className={classNames(classes.negative)} style={{ width: `${negativeBarWidth}%` }} />
        <div className={classNames(classes.middleMark)} />
        <div className={classNames(classes.positive)} style={{ width: `${positiveBarWidth}%` }} />
      </div>
    </div>
  );
});
